import { Avatar, Empty, Card, Timeline } from "antd";
import RecordItem from "@/pages/clueManage/clueDetail/components/FollowUp/RecordItem.tsx";
import styles from "@/pages/saleOperations/saleWorkBench/customerDetail/index.module.less";
import React, { useContext, useEffect, useMemo, forwardRef, useImperativeHandle } from "react";
import {clueFollowLogList} from "@/services/callCenter";
import ClueDetailContext from "@/pages/clueManage/clueDetail/clueDetailContext.ts";
import {useSetState} from "ahooks";
import AddNewFollowModal from "@/pages/crm/sellPlan/components/AddNewFollowModal";
import dayjs from 'dayjs';
import { STags } from "shj-components";
import classNames from "classnames";

const colors = ['rgba(255, 90, 38, 1)', 'rgba(245, 147, 0, 1)', 'rgba(43, 164, 113, 1)', 'rgba(0, 100, 255, 1)', 'rgba(136, 81, 237, 1)', 'rgba(214, 32, 105, 1)']

const FollowUpRecords = forwardRef((props: any, ref: any) => {
  const {detailState, updateDetail} = useContext(ClueDetailContext)
  const [state, setState] = useSetState({
    loading: false,
    logList: [],
    openNewFollow: false,
  })

  useEffect(() => {
    detailState.id && getFollowUpRecord()
  }, [detailState.id, detailState.isReloadRecord]);

  // 获取跟进记录数据
  const getFollowUpRecord = () => {
    if (!detailState.id || state.loading) return;
    setState({loading: true});
    clueFollowLogList({orderBys: [{columnName: 'ID', asc: false}], clueId: detailState.id})
        .then((res: any) => {
          setState({logList: res || []})
        })
        .finally(() => {
          setState({loading: false});
        });
  };

  const items = useMemo(() => {
    return state.logList?.map(item => ({key: item.id, children: <RecordItem key={item.id} item={item}/>}))
  }, [state.logList])

  const onAdd = () => {
    setState({openNewFollow: true})
  }

  useImperativeHandle(ref, () => ({
    onAdd,
  }))

  return <>
    {state.logList?.length ? <div className={styles.recordOverScrollBox}>
      {
        state.logList?.length ? state.logList?.map((item: any) => (
          <div className={styles.followRecord}>
            <div className={styles.followerInfo}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Avatar
                  size={24}
                  style={{
                    fontSize: '14px',
                    backgroundColor: colors[Math.round(item?.ucenterUserId ? Number(item?.ucenterUserId?.[item?.ucenterUserId?.length - 1] || 0) * 0.6 : 3)]
                  }}
                  className={styles.mr5}>{ item.name?.[0] }</Avatar>
                <span className={styles.name}>{ item.name }</span>
              </div>
              <span className={styles.time} style={{ lineHeight: '24px', color: 'rgba(135, 136, 138, 1)', marginRight: '4px' }}>
                {
                  dayjs(item.createdTime).format('YYYY-MM-DD HH:mm:ss')
                }
              </span>
            </div>
            <Card>
              <div className={classNames([styles.mb10, styles.flexStartCenter])}>
                <span className={styles.label}>操作：</span>
                <STags itemKey='' label={item.followerTypeName} fontColor="rgba(0, 168, 101, 1)" bgColor='rgba(215, 247, 234, 1)'></STags>
              </div>
              {item.beforeStatusName !== item.afterStatusName && <p className={classNames([styles.flexStartCenter, styles.mb10])}>
                <span className={styles.label}>状态变更：</span>
                <span className={styles.value}>{item.beforeStatusName} --&gt; {item.afterStatusName}</span>
              </p>}
              <div className={styles.flexStart}>
                <span className={styles.label}>内容：</span>
                <span className={styles.value}>{item.content}</span>
              </div>
            </Card>
          </div>
        )) : null
      }
    </div> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
    {/** 新增跟进弹窗 */}
    {state.openNewFollow && <AddNewFollowModal buttonKey={''}
                                               isSeat={true}
                                               reload={getFollowUpRecord}
                                               editId={detailState.id}
                                               open={state.openNewFollow}
                                               onClose={() => setState({openNewFollow: false})}/>}
  </>
})

export default FollowUpRecords
